/* ═══════════════════════════════════════════════════
   COREFLOW DARK GLASS — Graphite + Frosted Glass
   Background: #2C2E33 (Graphite Dark)
   Glass: Frosted dark with subtle light borders
   Text: Light (#FAFAFA)
   Accent: Precision Blue (#FAFAFA)
   Borders/Dividers: #D9DBDD (light silver)
   ═══════════════════════════════════════════════════ */

const T = {
  bg: "#2C2E33",
  bgAlt: "#25272B",

  // Glass — frosted dark panels with light edge catches
  glass: "rgba(255,255,255,0.06)",
  glassHover: "rgba(255,255,255,0.10)",
  glassBorder: "rgba(217,219,221,0.15)",
  glassBorderHover: "rgba(217,219,221,0.25)",
  glassBlur: "blur(20px) saturate(1.8)",
  glassShadow: "0 8px 40px rgba(0,0,0,0.25), 0 1px 3px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.05)",

  glass2: "rgba(255,255,255,0.04)",
  glass2Border: "rgba(217,219,221,0.10)",
  glass3: "rgba(255,255,255,0.08)",
  glass3Border: "rgba(217,219,221,0.18)",
  glassEdge: "inset 0 1px 0 rgba(255,255,255,0.06)",

  // Surfaces — dark glass
  sf: "rgba(255,255,255,0.06)",
  sf2: "rgba(255,255,255,0.03)",
  card: "rgba(255,255,255,0.06)",
  cardH: "rgba(255,255,255,0.10)",

  // Sidebar
  sidebarBg: "#2C2E33",
  sidebarBdr: "rgba(217,219,221,0.10)",
  sidebarTxt: "#FAFAFA",
  sidebarHi: "#FAFAFA",
  sidebarHover: "rgba(64,89,173,0.12)",
  sidebarActive: "rgba(64,89,173,0.20)",

  // Borders — light silver on dark
  bdr: "rgba(217,219,221,0.12)",
  bdrGlow: "rgba(217,219,221,0.15)",
  bdrH: "rgba(217,219,221,0.22)",

  // Text — light on dark
  txt: "#FAFAFA",
  tx2: "#FAFAFA",
  tx3: "#FAFAFA",
  tx4: "#FAFAFA",

  // Brand — Precision Blue
  blue: "#4059AD",
  blueLt: "#6B83D4",
  blueG: "rgba(64,89,173,0.12)",
  blueS: "rgba(64,89,173,0.25)",
  blueGlow: "0 0 20px rgba(64,89,173,0.25)",

  // Status
  grn: "#22C55E",
  grnD: "rgba(34,197,94,0.12)",
  red: "#EF4444",
  redD: "rgba(239,68,68,0.12)",
  amb: "#F59E0B",
  ambD: "rgba(245,158,11,0.12)",
  cyn: "#06B6D4",
  cynD: "rgba(6,182,212,0.12)",
  pur: "#8B5CF6",
  purD: "rgba(139,92,246,0.12)",
  slate: "#FAFAFA",

  // Brand identity
  graphite: "#2C2E33",
  onyx: "#3B3F45",
  silver: "#D9DBDD",
  slateBlue: "#94A3B8",
  precisionBlue: "#4059AD",

  // ═══ MOTION SYSTEM ═══
  spring: "cubic-bezier(0.175, 0.885, 0.32, 1.1)",
  springSnap: "cubic-bezier(0.34, 1.56, 0.64, 1)",
  ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
  easeOut: "cubic-bezier(0.16, 1, 0.3, 1)",
  easeIn: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  easeInOut: "cubic-bezier(0.65, 0, 0.35, 1)",

  fast: "0.15s",
  med: "0.3s",
  slow: "0.5s",
  slower: "0.7s",

  stagger: 0.04,
};

T.transition = {
  fast: `all ${T.fast} ${T.ease}`,
  med: `all ${T.med} ${T.ease}`,
  slow: `all ${T.slow} ${T.easeOut}`,
  spring: `all ${T.med} ${T.spring}`,
  springSnap: `all 0.25s ${T.springSnap}`,
  hover: `all ${T.fast} ${T.ease}`,
  page: `all ${T.slow} ${T.easeOut}`,
  modal: `all 0.4s ${T.easeOut}`,
  color: `color ${T.fast} ${T.ease}, background ${T.fast} ${T.ease}`,
  transform: `transform ${T.med} ${T.spring}`,
  opacity: `opacity ${T.med} ${T.ease}`,
};

export default T;
